export default "__VITE_ASSET__70ca7dff__"